'use strict';
var $ = require('../internals/export');

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.number.min-safe-integer.js
// module id = 784
// module chunks = 0